import React, { Component } from 'react';
import Form from './Form'
import './Main.css'

class Main extends Component {
    constructor () {
        super()
    }
    render(){
        return(
            <div className = "Main">
                <p className = "Fave">Your fave: {""+this.props.fave}</p>
                <p className = "PickFave">Pick a new fave: </p>
                <Form fave={this.props.fave} handleChange={this.props.handleChange} number={this.props.number} carrier={this.props.carrier} submit = {this.props.submit}/>
                <p>Your number: {""+this.props.number}</p>
                <p>Your carrier: {""+this.props.carrier}</p>
                <button
                    onClick={this.props.signOut}
                    className="button"
                >
                
                <a>Sign Out</a>
                </button>
            </div>
        )
    }
}

export default Main


// WEBPACK FOOTER //
// ./src/Main.js